/**
 * Copyright (c) 2025 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useEffect } from 'react';
import { useRootSelector } from '../../../hooks/useRootSelector';
import { initAppcuesForNotaries } from '../../../api/appcues';
import { usePermissions } from '../../../hooks/usePermissions';
import { isGroupAdmin } from '@utils/permissions';

interface NotaryRouteWrapperProps {
  children: React.ReactNode;
}

export const NotaryRouteWrapper: React.FC<NotaryRouteWrapperProps> = ({ children }) => {
  const { user: notaryUser } = useRootSelector(state => ({
    user: state.user,
  }));
  const permissions = usePermissions();
  const isAdmin = isGroupAdmin(permissions);

  // Initialize Appcues for notaries
  useEffect(() => {
    if (notaryUser?.id) {
      initAppcuesForNotaries(notaryUser.id, isAdmin);
    }
  }, [notaryUser, isAdmin]);

  return <>{children}</>;
};
